// 全局搜索 hook —— 消费 /api/v1/search?q=&limit=
// F60：CommandPalette 使用；debounce 由外部（useDebounced）处理
// staleTime 5s + keepPreviousData：避免抖动、切键盘时保留旧结果

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { api } from './api.js';

import type { SearchResult } from '@aliashub/shared/dto';

export type { SearchResult } from '@aliashub/shared/dto';

/** 简单 debounce hook */
export function useDebounced<T>(value: T, ms = 200): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

const LIMIT = 8;

export function useSearch(q: string, enabled = true) {
  const trimmed = q.trim();
  const canSearch = enabled && trimmed.length >= 2;
  return useQuery<SearchResult>({
    queryKey: ['search', trimmed] as const,
    queryFn: () =>
      api.get<SearchResult>(
        `/api/v1/search?q=${encodeURIComponent(trimmed)}&limit=${String(LIMIT)}`,
      ),
    enabled: canSearch,
    staleTime: 5_000,
    placeholderData: keepPreviousData,
  });
}
